<template>
  <div style="width: 100%; background: #ffffff">
    <div class="count_center">
      <div class="centerCoutn" style="height: 202px;display: flex;align-items: center;margin-top: 46px;">
        <div style="display: flex;align-items: center;flex: 1;">
          <i
            style="font-size: 55px; color: #00c300;margin-left: 50px;margin-right: 30px;"
            class="el-icon-success animate__animated animate__bounceInDown"
          ></i>
          <div style="line-height: 1;color: #333333;">
            <p style="font-size: 24px;font-weight: bold;">委托完成  等待货物入仓</p>
            <p style="margin-top: 14px;font-size: 18px;font-weight: 500;" v-if="needRecharge">您当前为票结用户，该票预估金额{{ price }}元，您需先预付充值才可出库</p>
          </div>
        </div>
        <div class="recharge-btn" @click="payVisible = true" v-if="needRecharge">立即充值</div>
      </div>
    </div>
    <!-- --------------------------------内容 -->
    <div class="count_center">
      <div class="centerCoutn" style="margin-top: 33px;">
        <div style="width: 100%; margin-top: 57px">
          <!-- <i
            style="font-size: 55px; color: #00c300"
            class="el-icon-success animate__animated animate__bounceInDown"
          ></i>
          <p
            style="
              font-size: 20px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-top: 27px;
            "
          >
            委托完成
          </p>
          <p
            style="
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #999999;
              margin-top: 8px;
            "
          >
            等待货物入仓
          </p> -->
          <div class="countText">
            <el-col :span="12">
              <p>运单号：{{ innos }}</p>
            </el-col>

            <div v-if="!isPrivate">
              <el-col :span="12">
                <p>
                  仓库代码：<span>{{ toFABck.namec }}</span>
                  <span style="margin-left: 10px">{{ toFABck.tel }}</span>
                </p>
              </el-col>
              <el-col :span="12">
                <p>收货地址：{{ toWarehouseAddress }}</p>
              </el-col>
            </div>
            <div v-else>
              <el-col :span="12">
                <p>
                  收货人：<span>{{ recAddressDTO.recGoodsPerson }}</span
                  >/<span>{{ recAddressDTO.recGoodsTel }}</span>
                </p>
              </el-col>
              <el-col :span="12">
                <p>
                  收货地址：{{ recAddressDTO.recwarehouseaddress }}
                  {{ recAddressDTO.recgoodscity }}
                  {{ recAddressDTO.recGoodsState }}
                  {{ recAddressDTO.recGoodsPostcode }}
                  {{ recAddressDTO.recgoodscountry }}
                </p>
              </el-col>
            </div>
            <p
              v-if="
                this.isFastOrder == true && this.isUploadAttachment == false
              "
            >
              <span
                style="color: #FF4D01; cursor: pointer"
                @click="excelVisibleBtn()"
                >我要上传装箱清单</span
              >(装箱单发票暂未上传，也可到“我的订单”补充)
            </p>
          </div>
        </div>
        <div class="btnWrap" style="width: 100%; margin-top: 44px">
          <div class="LR_center" style="width: 328px">
            <div class="btn1" @click="pathBilltab()">查看订单</div>
            <div class="btn2" style="margin: 0 10px" @click="nextSetbill()">
              继续下单
            </div>
            <el-button
              v-if="
                this.isFastOrder == false ||
                this.isUploadAttachment ||
                this.fileName != ''
              "
              style="height: 30px; margin: 3px 0"
              type="success"
              size="mini"
              @click="downLoadLabel()"
              >下载标签</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Excel上传 -->
    <el-dialog title="文件上传" :visible.sync="excelVisible" width="40%" center>
      <div class="helper">下载产品装箱单模板，并填写后上传</div>

      <div v-if="elTag" center style="text-align: center; margin: 30px 0">
        <el-tag type="success" @close="handleClose()">{{ fileName }}</el-tag>
        <span
          v-if="isReupdateFile"
          @click="reUpdateFile"
          style="color: #FF4D01; cursor: pointer"
          >重新上传</span
        >
      </div>

      <!-- 12位 -->
      <el-upload
        style="text-align: center"
        :show-file-list="false"
        :on-error="handleError"
        :on-success="handleSuccess"
        :before-upload="handleBeforeUpload"
        :http-request="uploadSectionFile"
        class="upload-demo"
        drag
        action=""
        multiple
        v-if="excelVisibleSync"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>

      <div class="helper" style="margin-top: 10px">
        <el-button size="mini" type="success" @click="Getdown()"
          >下载模板</el-button
        >
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          style="margin-right: 20px"
          size="mini"
          @click="excelVisible = false"
          >取 消</el-button
        >
        <el-button
          style="margin-right: 20px; background: #FF4D01; color: #fff"
          size="mini"
          @click="excelVisible = false"
          >确认</el-button
        >
      </span>
      <template>
        <el-table
          v-show="errorLabel.length > 0"
          :data="errorLabel"
          size="mini"
          border
          style="width: 100%"
        >
          <el-table-column align="center" width="50" type="index" label="序号">
          </el-table-column>
          <el-table-column
            align="center"
            width="80"
            prop="order"
            label="错误行"
          >
          </el-table-column>
          <el-table-column label="错误描述">
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.desc }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>

    <PayDialog
      :visible="payVisible"
      @close="payVisible = false"
      @show="payVisible = true"
    ></PayDialog>
  </div>
</template>

<script>
import Driver from "driver.js";
import qs from "qs";
import {sendCustomerOperationRecord} from "@/assets/js/utils";
import PayDialog from "@/components/PersonalCenter/components/pay-dialog";
export default {
  components: { PayDialog },
  data() {
    return {
      driverEnter: null, // 引导页面
      recAddressDTO: {},
      isPrivate: JSON.parse(sessionStorage.getItem("isPrivate")),
      innos: this.$route.query.innos,
      billId: "",
      isFastOrder: this.$route.query.isFastOrder,
      toFABck: JSON.parse(sessionStorage.getItem("toFABck")),
      excelVisible: false,
      fileName: "",
      fileUrlList: "",
      fileSize: "",
      errorLabel: [],
      elTag: false,
      excelVisibleSync: false,
      isUploadAttachment: "",
      orderNo: "",
      // excelVisibleUpadte: false,
      isReupdateFileTrue: false,
      isReupdateFile: false,
      toWarehouseAddress: this.$route.query.toWarehouseAddress,
      payVisible: false,
      needRecharge: false,
      price: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 下载标签
    downLoadLabel() {
      sendCustomerOperationRecord("下载标签");
      this.axios
        .get(`/busFbx/downFBXOrderLabel/${this.$route.query.nos}`)
        .then((res) => {
          if (res.data.code == 200) {
            let a = document.createElement("a");
            a.setAttribute("href", res.data.data);
            a.setAttribute("target", "_blank");
            a.click();
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // downLoadBill(){

    //   this.axios.get(`/arap/getInWarehouseLabel/${this.billId}`,{
    //     responseType: 'arraybuffer'  /* 一定要加这个 不然文件内容显示不了 */
    //     })
    //   .then((res) => {
    //           let a = document.createElement('a');
    //           let blob = new Blob([res.data]);
    //           let objectUrl = URL.createObjectURL(blob);
    //           a.setAttribute("href",objectUrl);
    //           a.setAttribute("download", '入仓单.xls');
    //           a.click();
    //           // console.log(objectUrl);
    //           URL.revokeObjectURL(elink.href); // 释放URL 对象
    //           document.body.removeChild(a);// 释放标签

    //   }) .catch((res) => {
    //   console.log(res);
    //   });

    // },
    nextSetbill() {
      sendCustomerOperationRecord("继续下单")
      this.$router.push("/index/placeOrder/placeIndex");
      this.$store.commit("changeactive", 1);
      // 删除本地缓存
      sessionStorage.removeItem("fromFABck");
      sessionStorage.removeItem("THFdata");
      sessionStorage.removeItem("toFABck");
      sessionStorage.removeItem("inwarehousetime");
      sessionStorage.removeItem("todoordate");
      sessionStorage.removeItem("todoorTime");
      sessionStorage.removeItem("countLIst_T");
      sessionStorage.removeItem("goodsTypeId");
      sessionStorage.removeItem("FBATransmoney");
      sessionStorage.removeItem("FeeLIst");
      sessionStorage.removeItem("delgoodsremarks");
      sessionStorage.removeItem("recgoodremarks");
      sessionStorage.removeItem("getgoodsremarks");
    },
    pathBilltab() {
      sendCustomerOperationRecord("查看订单")
      let pathData = {
          code: "",
          icon:'',
          level:'',
          name:'',
          nextNodes:'',
          parentId: '',
          resourceId: '',
      }
      if (this.isPrivate) {
          pathData.code = `/index/PersonalCenter/Personalindex/PersonalCenter/PrivateAddrs/PrivateOrderDetails/1/${this.$route.query.id}`
          pathData.name = `${this.$route.query.nos}详情`
          this.$store.commit("mutationSelectTags", pathData);
          this.$router.push(`/index/PersonalCenter/Personalindex/PersonalCenter/PrivateAddrs/PrivateOrderDetails/1/${this.$route.query.id}`)

        // this.$router.push({
        //   name: "PrivateOrderDetails",
        //   params: {
        //     id: this.$route.query.id,
        //   },
        // });
      } else {

        pathData.code = `/index/PersonalCenter/Personalindex/PersonalCenter/FBAheader/FbaOrderDetails/${this.$route.query.state}/${this.$route.query.nos}/${true}/${this.$route.query.thirdNos}`
        pathData.name = `${this.$route.query.nos}详情`
        this.$store.commit("mutationSelectTags", pathData);
        this.$router.push(`/index/PersonalCenter/Personalindex/PersonalCenter/FBAheader/FbaOrderDetails/${this.$route.query.state}/${this.$route.query.nos}/${true}/${this.$route.query.thirdNos}`)
      }

      sessionStorage.removeItem("fromFABck");
      sessionStorage.removeItem("THFdata");
      sessionStorage.removeItem("toFABck");
      sessionStorage.removeItem("inwarehousetime");
      sessionStorage.removeItem("todoordate");
      sessionStorage.removeItem("todoorTime");
      sessionStorage.removeItem("countLIst_T");
      sessionStorage.removeItem("goodsTypeId");
      sessionStorage.removeItem("FBATransmoney");
      sessionStorage.removeItem("FeeLIst");
      sessionStorage.removeItem("delgoodsremarks");
      sessionStorage.removeItem("recgoodremarks");
      sessionStorage.removeItem("getgoodsremarks");
    },

    //下载模板
    Getdown() {
      //下载模板
      this.axios
        .get(`/busFbx/downFBXBoxGoodsTemplate`, {
          responseType: "arraybuffer" /* 一定要加这个 不然文件内容显示不了 */,
        })
        .then((res) => {
          if (res.status) {
            let a = document.createElement("a");
            let blob = new Blob([res.data]);
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", "导入模板V2.0.xls");
            a.click();
            URL.revokeObjectURL(objectUrl); // 释放内存
          } else {
          }
        })
        .catch((res) => {});
    },

    //失败时的方法
    handleError(err) {
      this.$message.info(err.data);
    },
    //成功时的方法
    handleSuccess(response) {
      if (response.isSuccess) {
        this.$message.success(response.error);
        return;
      }
      this.$message.info(response.error);
    },
    // 上传前
    handleBeforeUpload(file) {
      // 校验
      let legalName = ["xls"];
      // 拿到后缀名
      let name = file.name.substring(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (legalName.includes(name)) {
        // console.log(legalName.includes(name));
      } else {
        this.$message.info("文件格式不对，仅限xls");
        return false;
      }
    },
    //上传
    uploadSectionFile(params) {
      // let boxNoType = 1;
      let form = new FormData();
      form.append("file", params.file);
      // form.append("boxNoType", boxNoType);
      form.append("orderNo", this.orderNo);
      this.axios
        .post(`/busFbx/reUploadOrderAttachment`, form)
        .then((res) => {
          if (res.data.code == 200) {
            this.excelVisibleSync = false;
            this.elTag = true;
            this.isReupdateFile = true;
            this.fileName = res.data.data.fileName;
            this.fileUrl = res.data.data.fileUrl;
            this.fileSize = res.data.data.fileSize;
            this.$message.info(res.data.message);
            this.errorLabel = [];
            // this.ruleform.formLIst = res.data.data;
          }
          if (res.data.code == -1) {
            this.errorLabel = res.data.data;
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 关闭按钮
    handleClose() {
      this.excelVisibleSync = true;
      this.elTag = false;
      this.fileName = "";
      this.fileUrlList = "";
      this.fileSize = "";
    },

    // 重新上传
    reUpdateFile() {
      this.elTag = false;
      this.isReupdateFile = false;
      this.excelVisibleSync = true;
    },

    // 打开12位上传文件
    excelVisibleBtn() {
      this.excelVisible = true;
      this.excelVisibleSync = true;
      this.errorLabel = [];
      if (this.fileName == "" || this.fileName == null) {
        this.elTag = false;
        this.isReupdateFile = false;
      } else {
        this.elTag = true;
        this.isReupdateFile = true;
        this.excelVisibleSync = false;
      }
    },

    // 查询引导页面
    gudieData() {
      console.log("---");
      // debugger
      this.driverEnter = new Driver({
        className: "scoped-class", // className to wrap driver.js popover
        animate: true, // Animate while changing highlighted element
        opacity: 0.5, // Background opacity (0 means only popovers and without overlay)
        padding: 10, // Distance of element from around the edges
        // 点击其他区域是否关闭弹框： false：点击其他区域不关闭弹框 true：点击其他区域关闭弹框
        allowClose: false, // Whether clicking on overlay should close or not
        overlayClickNext: false, // Should it move to next step on overlay click
        doneBtnText: "我知道了", // Text on the final button
        closeBtnText: "跳过指引", // Text on the close button for this step
        nextBtnText: "下一步", // Next button text for this step
        prevBtnText: "上一步", // Previous button text for this step
        onHighlightStarted: (Element) => {
          console.log("statrt", Element);
        },
        onDeselected: (Element) => {
          console.log("statrt---");
          this.$store.state.isCover = false;
        },
        onReset: (Element) => {
          console.log("done");
          localStorage.setItem("driverType4", false);
        },
        // Called when moving to next step on any step
      });
      let steps = [
        {
          element: ".LR_center",
          popover: {
            title: `<div class="t11" style="display: flex;justify-content: space-between;font-size: 18px;">
          <div>委托完成可继续下单或查看订单</div>
          <div class="test1"></div>
        </div>`,
            // description: `<div style="color: red;" class="t1">123</div>`,
            position: "bottom",
          },
          padding: 5,
          offset: 30,
        },
      ];

      // card_wrap
      this.driverEnter.defineSteps(steps);
      this.driverEnter.start();
      this.driverEnter.steps.forEach(
        (el) => (el.node.style.pointerEvents = "none")
      );

      this.interval1 = setInterval(() => {
        if (!this.driverEnter.isActivated) {
          this.driverEnter.steps.forEach(
            (el) => (el.node.style.pointerEvents = "auto")
          );
          clearInterval(this.interval1);
        }
      }, 100);
    },
  },
  created() {
    // 获取id 下载入仓单
    this.billId = this.$route.query.nos2;
    this.innos = this.$route.query.innos;
    this.isFastOrder = this.$route.query.isFastOrder === 'true';
    this.isUploadAttachment = this.$route.query.isUploadAttachment === 'true';
    this.orderNo = this.$route.query.orderNo;
    this.recAddressDTO = this.$route.query.recAddressDTO ? JSON.parse(this.$route.query.recAddressDTO) : {};
    this.needRecharge = this.$route.query.needRecharge
    this.price = this.$route.query.price
  },
  mounted() {

  },
};
</script>
<style scoped>
.helper {
  width: 100%;
  height: 15%;
  color: #FF4D01;
  align-content: center;
  text-align: center;
  font-size: 20px;
  margin-bottom: 20px;
}

.btn1 {
  width: 157px;
  height: 36px;
  background: #ffffff;
  border: 1px solid #FF4D01;
  border-radius: 5px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #FF4D01;
  cursor: pointer;
}
.btn2 {
  width: 157px;
  height: 36px;
  background: #FF4D01;
  border-radius: 5px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.countText {
  /* padding-top: 31px; */
  /* width: 450px; */
  margin: 0 auto;
  /* text-align: left; */
  padding-left: 50px;
  box-sizing: border-box;
}
.countText p {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  margin-bottom: 30px;
}
.center_wrap {
  width: 100%;
}
.centerCoutn {
  width: 1200px;
  height: 258px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  /* border-radius: 10px; */
  margin-top: 40px;
}
.header_wrap {
  width: 100%;
  height: 121px;
  margin-top: 33px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.fontString {
  font-weight: bold;
}
.shouMargin {
  margin-bottom: 10px;
}
.ckttext {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #9a9a9a;
}
.good_count {
  margin-top: 65px;
}
.header_text {
  text-align: center;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.count {
  width: 100%;
  padding-top: 30px;
}
.dialog >>> .el-dialog__body {
  padding: 0px 30px 30px 30px !important;
}
.dialog >>> .el-dialog__header {
  padding: 10px !important;
}
.tittype {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-left: 10px;
}
.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 778px;
}
/* 左右对齐 */
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.popWrap_l {
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.btnWrap {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
/* 垂直居中 */
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* column垂直 */
  flex-direction: column;
}
.recharge-btn {
  width: 221px;
  height: 56px;
  margin-right: 30px;
  background: #FF4D01;
  border-radius: 28px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 56px;
  text-align: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/FBAorder/FbaorderSuccess.vue